/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiAgentV2ControllerStreamResponseQueryResponse, AiAgentV2ControllerStreamResponsePathParams } from "../../models/aiAgentV2Controller/AiAgentV2ControllerStreamResponse";

function getAiAgentV2ControllerStreamResponseUrl(requestId: AiAgentV2ControllerStreamResponsePathParams["requestId"]) {
  const res = { method: 'GET', url: `/api/v1/ai-agent-v2/stream/${requestId}` as const }  
  return res
}

/**
 * @description Streams real-time agent events from Redis Streams.
 * @summary Stream agent responses via Server-Sent Events
 * {@link /api/v1/ai-agent-v2/stream/:requestId}
 */
export async function aiAgentV2ControllerStreamResponse(requestId: AiAgentV2ControllerStreamResponsePathParams["requestId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AiAgentV2ControllerStreamResponseQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAiAgentV2ControllerStreamResponseUrl(requestId).url.toString(), ... requestConfig })  
  return res.data
}